import { useState, useEffect } from 'react';
import { InputText, InputSize, IconFile, IconClose } from '@ui/src';
import { UploadedApplicationDocument } from '../types';

import cn from '../new-application.module.css';

let timeout: NodeJS.Timeout;

const UploadedFile = ({
  item,
  onDelete,
  items,
  setUploadedFiles,
  error,
  attachedFiles,
}: UploadedApplicationDocument) => {
  const [fileName, setFileName] = useState(item.name);

  const onChange = (text: string) => {
    clearTimeout(timeout);
    setFileName(text);

    timeout = setTimeout(() => {
      const nextUploadedFiles = items?.map((fileItem) => {
        const result = { ...fileItem };

        if (result.id === item.id) {
          result.name = text;
        }

        return result;
      });

      setUploadedFiles(nextUploadedFiles);
    }, 500);
  };

  useEffect(() => {
    if (item) {
      setFileName(item.name);
    }
  }, [item]);

  return (
    <>
      <div className={cn.uploadedDocument} key={item.id}>
        <IconFile className={cn.uploadedFileIcon} />
        <InputText
          name="fileName"
          value={fileName}
          size={InputSize.SMALL}
          placeholder="Enter file name"
          onChange={(e) => onChange(e.target.value)}
          disabled={Boolean(attachedFiles?.find((id) => id === item.id))}
        />
        {!attachedFiles?.find((id) => id === item.id) && (
          <button
            type="button"
            className={cn.removeDocumentButton}
            onClick={() => onDelete(item.id)}
            aria-label="Close button"
          >
            <IconClose />
          </button>
        )}
      </div>
      {attachedFiles?.find((id) => item.id === id) && (
        <div className={cn.attachedFile}>Document already uploaded</div>
      )}
      {error && <div className={cn.uploadedDocumentError}>{error}</div>}
    </>
  );
};

export default UploadedFile;
